
export function checkConsent( serviceName ) {
	return new Promise( ( resolve ) => {
		if ( window.UC_UI ) {
			const service = window.UC_UI.getServicesBaseInfo().find( ( {name} ) => serviceName === name );
			const hasService = service && 'consent' in service;
			resolve( ! hasService || service.consent.status );
		} else {
			// Consent Handling - Resolve, when the consent was given.
			window.addEventListener( 'UC_GENERAL', ( ev ) => {
				const hasService = ev.detail && serviceName in ev.detail;
				resolve( ! hasService || ev.detail[ serviceName ] );
			} );
		}
	} );
}
